module.exports = __webpack_public_path__ + "static/media/logo-color.a427ebc6.svg";